import { defineRouting } from "next-intl/routing";

/**
 * Locale routing config. English is the default (served at /en); French,
 * Spanish, German, and Japanese are the additional supported locales.
 */
export const routing = defineRouting({
  locales: ["en", "fr", "es", "de", "ja"],
  defaultLocale: "en",
});

export type Locale = (typeof routing.locales)[number];

/**
 * Shape of the `[locale]` route params, shared by layouts and pages. The value
 * is `string` (not the `Locale` union) to satisfy Next.js's generated route
 * types; validate/narrow at runtime with `hasLocale` where needed.
 */
export type LocaleParams = { locale: string };
